import { render, staticRenderFns } from "./ttshop_invoiceIfdetails.vue?vue&type=template&id=3fec6924&scoped=true&"
import script from "./ttshop_invoiceIfdetails.vue?vue&type=script&lang=js&"
export * from "./ttshop_invoiceIfdetails.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_invoiceIfdetails.vue?vue&type=style&index=0&id=3fec6924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fec6924",
  null
  
)

export default component.exports